export function isClickable(props) {
  return Boolean(props.onClick || props.onMouseDown || props.href || props.to);
}
